import { render, staticRenderFns } from "./InvoiceFilesView.vue?vue&type=template&id=0f863752&scoped=true&"
import script from "./InvoiceFilesView.vue?vue&type=script&lang=js&"
export * from "./InvoiceFilesView.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceFilesView.vue?vue&type=style&index=0&id=0f863752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f863752",
  null
  
)

export default component.exports